<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="设备收益" name="1"></el-tab-pane>
      <el-tab-pane label="贡献收益" name="2" v-if="level === 'AREA'"></el-tab-pane>
      <el-tab-pane label="提现支出" name="3"></el-tab-pane>
    </el-tabs>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-table ref="table" :columns="columns" :defaultParams="defaultParams" :api="api">
      <template #status="row">
        <!-- {{ row.data.inout === '1' ? '收入' : '支出' }} -->
        {{ typeStatus[row.data.type] }}
      </template>
      <template #createdTime="row">
        {{ row.data.createTime | formatDate }}
      </template>
      <template #sum="row"> {{ row.data.inout === '1' ? '+' : '-' }}{{ row.data.sum }} </template>
    </com-table>
  </div>
</template>

<script>
import { xdWalletTxFlowApi } from '@/api/finance'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.defaultParams.refUser = val
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      api: xdWalletTxFlowApi,
      activeName: '0',
      defaultParams: {
        type: ''
      },
      typeStatus: {
        1: '充值',
        2: '充电',
        3: '充电赠送',
        4: '充电分成',
        5: '合伙人贡献收益',
        6: '商家分成',
        7: '月卡分成',
        10: '充电退款 ',
        11: '充值退款',
        20: '发起提现',
        21: '提现',
        22: '提现退回',
        8: '充值分成'
      },
      searchColumns: [
        {
          label: '类型',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '充电分成',
              value: 4
            },
            {
              label: '合伙人贡献收益',
              value: 5
            },
            {
              label: '提现',
              value: 21
            },
            {
              label: '充值收入',
              value: 8
            },
            {
              label: '用户提现退款',
              value: 11
            }
          ]
        },
        {
          label: '时间范围',
          prop: 'date',
          type: 'date'
        }
      ],
      columns: [
        {
          label: '日期',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createdTime'
        },
        {
          label: '订单编号',
          prop: 'remarks'
        },
        {
          label: '流水号',
          prop: 'transactionId'
        },
        {
          label: '类型',
          prop: 'type',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '金额',
          prop: 'sum',
          type: 'slot',
          slotName: 'sum'
        },
        {
          label: '账户余额',
          prop: 'afterWalletSum'
        }
      ]
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    },
    handleClick() {
      if (this.activeName === '0') this.defaultParams.type = ''
      if (this.activeName === '1') this.defaultParams.type = 4
      if (this.activeName === '2') this.defaultParams.type = 5
      if (this.activeName === '3') this.defaultParams.type = 21
      this.$refs.table.init()
    }
  }
}
</script>

<style lang="scss" scoped></style>
